import { Autocomplete, TextField } from "@mui/material";
import React from "react";
interface Props {
  attrName: any;
  title: string;
  value: string;
  value_update: Function;
  multiple_data: Array<any>;
  class_name?: string;
}

const defaultProps: Props = {
  title: "",
  value: "",
  attrName: "",
  value_update: () => {},
  multiple_data: [],
};

const MultipleSearchDropdown: React.FC<Props> = ({
  attrName,
  title,
  value,
  multiple_data,
  class_name,
  value_update,
}) => {
  return (
    <div className={class_name}>
      <Autocomplete
        multiple
        options={multiple_data}
        disableCloseOnSelect
        getOptionLabel={(option) => option.key}
        renderOption={(props, option, { selected }) => (
          <li {...props}>
            {option.key} 
          </li>
        )}
        renderInput={(params) => <TextField {...params}  label={title} />  }
      />     
    </div>
  );
};

MultipleSearchDropdown.defaultProps = defaultProps;
export default MultipleSearchDropdown;
